import {
  GET_INVESTMENT_INFORMATION,
  GET_INVESTMENT_TYPE_INFORMATION,
  GET_SELECTED_INVESTMENT_INFORMATION,
  GET_INVESTMENT_ENTITY_INFORMATION,
  GET_PROJECTION_MODEL,
  GET_PROJECTION_API_RESPONSE,
  GET_INVESTMENT_CHART_MODEL,
  GET_COMPARE_INVESTMENTS_INFO,
} from "../../../helpers/vuex-constants";

export default {
  [GET_INVESTMENT_INFORMATION](state) {
    return state.investmentdata;
  },
  [GET_PROJECTION_MODEL](state) {
    return state.projectionModel;
  },
  [GET_SELECTED_INVESTMENT_INFORMATION](state) {
    return state.selectedInvestment;
  },
  [GET_INVESTMENT_TYPE_INFORMATION](state) {
    return state.investmentType;
  },
  [GET_INVESTMENT_ENTITY_INFORMATION](state) {
    return state.investmentEntitiesInfo;
  },
  [GET_PROJECTION_API_RESPONSE](state) {
    return state.projectionAPIResponse;
  },
  [GET_INVESTMENT_CHART_MODEL](state) {
    return state.investmentChartModel;
  },
  [GET_COMPARE_INVESTMENTS_INFO](state) {
    return state.compareInvestments;
  },
};
